<template>
  <div class="header">
    <div class="content">
      <div class="logo">
        <img src="../../static/images/logo.png" class="icon" />
      </div>
      <nav class="navbar navbar-expand-lg navbar-light bg-light" @mouseleave="mouseLeaveParent()">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon">
            <i class="el-icon-menu"></i>
          </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <template v-for="(item,index) in menuList" v-if="!item.meta.hidden">
              <li class="nav-item" v-if="!item.children">
                <template>
                  <router-link :to="item.path" class="nav-link">
                    <span :class="['parentClass',{'active1':index==activeIndex}]" @mouseenter="mouseParent(index)" @click="checkMenu(index)">{{item.meta.name}}</span>
                  </router-link>
                </template>
              </li>
              <li class="nav-item dropdown" v-else>
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                  <span :class="['parentClass',{'active1':index==activeIndex}]" @mouseenter="mouseParent(index)" @click="checkMenu(index)">{{item.meta.name}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu1" aria-labelledby="navbarDropdown" @mouseleave="momuseLeave" v-if="item.meta.name=='功能教室解决方案'">
                  <div class="SeconddropdownMenu">
                    <template v-for="(child,index) in item.children">
                      <div class="childMenu" @click="getChildMenu($event)" @mouseenter="mouseEnter($event)">
                        <router-link class="dropdown-item" :to="{path:child.path,query:{name:child.meta.name}}"><img :src="child.meta.icon" />
                          <!-- <span>{{child.meta.name}}</span> -->
                        </router-link>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="dropdown-menu dropdown-menu2" aria-labelledby="navbarDropdown" @mouseleave="momuseLeave" v-else-if="item.meta.name=='学习平台'">
                  <div class="SeconddropdownMenu">
                    <template v-for="(child,index) in item.children">
                      <div class="childMenu" @click="getChildMenu($event)" @mouseenter="mouseEnter($event)">
                        <a :href="child.path" target="_blank"><img :src="child.meta.icon" />
                          <!-- <span>{{child.meta.name}}</span> -->
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </li>
            </template>
            <p class="navline" id="navline"></p>
            <!-- <li class="nav-item">
              <a class="nav-link" href="#">首页</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">关于我们</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">课程中心</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                行业应用
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                创新平台
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                服务支持
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">新闻中心</a>
            </li> -->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      menuList: [],
      childActive: null,
      rouAct: null,
      activeMenu: null,
    };
  },
  watch: {
    '$route': function (to, from) {
      this.getParentMenu();
      if (to.path == "/DynamicDetails") {
        $("body").addClass("newCenter");
      } else {
        $("body").removeClass("newCenter");
      }
      if (to.path == "/AIEducation") {
        $("body").addClass("AIEducationBody");
      } else {
        $("body").removeClass("AIEducationBody");
      }
    }
  },
  methods: {
    checkMenu (i) {
      this.activeIndex = i;
      //this.getNavSliderLine();
      $(".childMenu").removeClass("active");
    },
    getNavSliderLine () {
      $(".footerMain_top .footer_right ul li").removeClass("active1");
      $(".footerMain_top .footer_right ul li").eq(this.activeIndex).addClass("active1");
      var posLeft = $("#navbarSupportedContent .navbar-nav li").eq(this.activeIndex).position().left;
      var outerW = $("#navbarSupportedContent .navbar-nav li").eq(this.activeIndex).outerWidth();
      $('#navline').stop().animate({
        left: posLeft + outerW / 2 + 5,
        //width: $(this).outerWidth() - 50,
        opacity: 1
      });
    },
    mouseParent (i) {
      $("#navbarSupportedContent .navbar-nav li .parentClass").removeClass("active1");
      $("#navbarSupportedContent .navbar-nav li").eq(i).find(".parentClass").addClass("active1");
    },
    mouseLeaveParent () {
      $("#navbarSupportedContent .navbar-nav li").find(".parentClass").removeClass("active1");
      $("#navbarSupportedContent .navbar-nav li").eq(this.activeIndex).find(".parentClass").addClass("active1");
    },
    getChildMenu (event) {
      $(".childMenu").removeClass("active");
      this.activeMenu = $(event.target);
      $(event.target).parents(".childMenu").addClass("active");
    },
    mouseEnter (event) {
      // console.log(event);
      $(".childMenu").removeClass("active");
      $(event.target).addClass("active");
    },
    momuseLeave () {
      $(".childMenu").removeClass("active");
      $(this.activeMenu).parents(".childMenu").addClass("active");
    },
    // activeParent () {
    //   this.childActive = null;
    //   this.rouAct = null;
    // },
    getParentMenu () {
      this.menuList.map((item, index) => {
        if (item.name == this.$route.meta.rouAct && !item.meta.hidden) {
          this.activeIndex = index;
          this.getNavSliderLine();
        }
      });
    }
  },
  created () {
    this.menuList = this.$router.options.routes[0].children;
    //console.log(this.$router.options.routes[0].children);

  },
  mounted () {
    this.$nextTick(() => {
      this.getParentMenu();
    });
    // if ($(".dropdown-item").hasClass("router-link-active")) {
    //   $(".router-link-active").parent().addClass("active");
    // }
    if (document.documentElement.clientWidth > 768) {
      $(".dropdown").off('click');
      $(".dropdown").mouseover(function () {
        $(this).addClass("show");
        $(this).find(".dropdown-menu").addClass("show");
      });
      $(".dropdown").mouseleave(function () {
        $(this).removeClass("show");
        $(this).find(".dropdown-menu").removeClass("show");
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/header.vue